import React from 'react';

const MarketPanelGainers = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Stock Gainer</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="gainers">
            <thead>
              <tr>
                <th>PREV. CLOSE</th>
                <th>HIGH</th>
                <th>SYMBOL</th>
                <th>LOW</th>
                <th>LTP</th>
                <th>CHANGE</th>
                <th>%CHNG</th>
                <th>CA</th>
                <th>OPEN</th>
                <th>VOLUME (Shares)</th>
                <th>VALUE (₹ Lakhs)</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item['PREV. CLOSE'] || '-'}</td>
                    <td>{item.HIGH || '-'}</td>
                    <td>{item.SYMBOL || '-'}</td>
                    <td>{item.LOW || '-'}</td>
                    <td>{item.LTP || '-'}</td>
                    <td>{item.CHANGE || '-'}</td>
                    <td>{item['%CHNG'] || '-'}</td>
                    <td>{item.CA || '-'}</td>
                    <td>{item.OPEN || '-'}</td>
                    <td>{item['VOLUME (Shares)'] || '-'}</td>
                    <td>{item['VALUE (₹ Lakhs)'] || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelGainers;